export default class FormField {
  constructor(initialValue, validators = [], errorMessage = null) {
    this.value        = (initialValue === null || initialValue === undefined) ? '' : initialValue;
    this.errorMessage = errorMessage
    this.validators   = [].concat(validators);
  }
}
